class CategoryFilters {
  constructor(filters) {
    this.setDomElements(filters);
    this.setInitialState();
    this.setFilters();
  }

  setDomElements(filters) {
    this.$filtersContainer = filters;
    this.$filterLinks = this.$filtersContainer.querySelectorAll('a[href^="#"]');
    this.$scope = this.$filtersContainer.closest(".main") || document;
    this.$grid = this.$scope.querySelector(".grid");
    this.$status = this.$scope.querySelector(".js-filters-status");
  }

  setCurrentLink(link) {
    let previous = this.$filtersContainer.querySelector('a[aria-current="true"]');
    if (previous) {
      previous.removeAttribute("aria-current");
    }
    if (link) {
      link.setAttribute("aria-current", "true");
    }
  }

  announceResults(category) {
    if (!this.$status) return;
    let total = this.$grid.querySelectorAll(".grid-item").length;
    let visible = this.$grid.querySelectorAll(".grid-item:not(.invis)").length;
    this.$status.textContent =
      category === "all"
        ? `Showing all ${total} items`
        : `Showing ${visible} of ${total} items`;
  }

  filterCategory(category) {
    let boxes = this.$grid.querySelectorAll(".grid-item");
    boxes.forEach((box) => {
      let shouldHide = category !== "all" && !box.classList.contains(category);
      box.classList.toggle("invis", shouldHide);
    });
    this.announceResults(category);
  }

  selectFilter(link) {
    let fallback = this.$filtersContainer.querySelector("a.all");
    let selected = link || fallback;
    if (!selected) return;

    let category = selected.getAttribute("href").slice(1);
    this.filterCategory(category);
    this.setCurrentLink(selected);
  }

  setInitialState() {
    let hash = window.location.hash;
    let initialLink = Array.from(this.$filterLinks).find(
      (link) => link.getAttribute("href") === hash
    );
    this.selectFilter(initialLink);
  }

  setFilters() {
    this.$filterLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        this.selectFilter(event.currentTarget);
      });
    });
  }
}

export default CategoryFilters;
